import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateShareColorThemeMutationVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
  colorTheme?: Types.InputMaybe<Types.ColorThemeEnum>;
}>;


export type UpdateShareColorThemeMutation = { __typename?: 'Mutation', updateShare?: { __typename?: 'UpdateSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, colorTheme: Types.ColorThemeEnum } | { __typename?: 'CollectionShare', id: string, colorTheme: Types.ColorThemeEnum } | null } | null };


export const UpdateShareColorTheme = /*#__PURE__*/ gql`
    mutation UpdateShareColorTheme($shareId: ID!, $colorTheme: ColorThemeEnum) {
  updateShare(input: {shareId: $shareId, settings: {colorTheme: $colorTheme}}) {
    share {
      id
      colorTheme
    }
  }
}
    ` as unknown as DocumentNode<UpdateShareColorThemeMutation, UpdateShareColorThemeMutationVariables>;

          

          export const useUpdateShareColorThemeMutation = (options?:MutationHookOptions<UpdateShareColorThemeMutation, UpdateShareColorThemeMutationVariables>) => useMutation(UpdateShareColorTheme, options);
          

          export type UpdateShareColorThemeMutationOptions = MutationHookOptions<UpdateShareColorThemeMutation, UpdateShareColorThemeMutationVariables>;

          

          export type UpdateShareColorThemeMutationResult = ReturnType<typeof useUpdateShareColorThemeMutation>[1];

          
